export default {
  LAST_ID_SEEN: 'LAST_ID_SEEN',
  MESSAGE_PREVIEW_DATA: 'messagePreviewData',
}
